const row = (
  MyStores,
  Marketplace,
  StoreName,
  Link,
  Remove,
  ReconnectLink
) => ({
  MyStores,
  Marketplace,
  StoreName,
  Link,
  Remove,
  ReconnectLink,
});

export { row };
